import React, { useState, useEffect } from 'react';
import API from '../../services/api';

const ReferenceManagement = () => {
    const [refs, setRefs] = useState([]);
    const [form, setForm] = useState({ ref_name: '', ref_code: '' });
    const [editId, setEditId] = useState(null);

    const fetchRefs = async () => {
        const res = await API.get('/v1/references');
        if (res.data.success) setRefs(res.data.data);
    };

    useEffect(() => { fetchRefs(); }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (editId) {
            await API.put(`/v1/references/${editId}`, form);
        } else {
            await API.post('/v1/references', form);
        }
        setForm({ ref_name: '', ref_code: '' });
        setEditId(null);
        fetchRefs();
    };

    const deleteRef = async (id) => {
        if (window.confirm("Are you sure?")) {
            await API.delete(`/v1/references/${id}`);
            fetchRefs();
        }
    };

    return (
        <div>
            <h4>Manage References</h4>
            <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                <input 
                    placeholder="Reference Name" 
                    value={form.ref_name} 
                    onChange={e => setForm({...form, ref_name: e.target.value})}
                    required 
                    style={inputStyle}
                />
                <input 
                    placeholder="Ref Code" 
                    value={form.ref_code} 
                    onChange={e => setForm({...form, ref_code: e.target.value})}
                    required 
                    style={inputStyle}
                />
                <button type="submit" style={btnStyle}>{editId ? 'Update' : 'Add'}</button>
            </form>

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ background: '#f8fafc', textAlign: 'left' }}>
                        <th style={tdStyle}>Name</th>
                        <th style={tdStyle}>Code</th>
                        <th style={tdStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {refs.map(r => (
                        <tr key={r.id} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={tdStyle}>{r.ref_name}</td>
                            <td style={tdStyle}>{r.ref_code}</td>
                            <td style={tdStyle}>
                                <button onClick={() => {setEditId(r.id); setForm({ref_name: r.ref_name, ref_code: r.ref_code})}} style={editBtn}>Edit</button>
                                <button onClick={() => deleteRef(r.id)} style={delBtn}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const inputStyle = { padding: '8px', borderRadius: '4px', border: '1px solid #ddd', flex: 1 };
const btnStyle = { padding: '8px 20px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' };
const tdStyle = { padding: '12px' };
const editBtn = { marginRight: '5px', color: 'blue', cursor: 'pointer', background: 'none', border: 'none' };
const delBtn = { color: 'red', cursor: 'pointer', background: 'none', border: 'none' };

export default ReferenceManagement;